'use client';

import { useEffect, useState } from 'react';
import {
  useCountries,
} from '../../client/dashboard/staticData';
import VisaCategoryList from './VisaCategoryList';
import BankDetailsForm from './BankDetailsForm';
import DocumentUploadForm from './DocumentUploadForm';
import CountrySelector from './CountrySelector';
import { useDispatch, useSelector } from 'react-redux';
import { fetchChecklists } from '../../../redux/features/checklistSlice';

const MainDocuments = () => {
  const countries = useCountries();
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [visaCategories, setVisaCategories] = useState([]);
  const dispatch = useDispatch();
  const { checklists } = useSelector((state) => state.checklist);

  const fetchVisaTypes = async (countryName) => {
      const country = countries?.find(c => c.name === countryName);
      if(!country) return;

      try {
          const token = localStorage.getItem('token');
          const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/visatype?countryId=${country._id}&isActive=true`, {
              headers: {
                  authorization: `bearer ${token}`,
              },
          });
          const data = await response.json();
          if(data?.body?.visaTypes){
              const formatted = data.body.visaTypes.map(vt => ({
                  ...vt,
                  label: vt.title, 
                  value: vt.title,
              }));
              console.log(formatted);
              setVisaCategories(formatted);
          } else {
              setVisaCategories([]);
          }
      } catch (error) {
          console.error("Error fetching visa types:", error);
          setVisaCategories([]);
      }
  };

  const handleVisaTypeUpdate = (updatedData) => {
    if (updatedData) {
      setVisaCategories((prev) =>
        prev.map((item) =>
          item._id === updatedData._id
            ? { ...updatedData, label: updatedData.title, value: updatedData.title }
            : item
        )
      );
      setSelectedCategory(updatedData.title);
    }
    fetchVisaTypes(selectedCountry);
  };

  useEffect(() => {
    if (checklists.length === 0) dispatch(fetchChecklists());
  }, [dispatch]);
  
  useEffect(() => {
     if (countries && countries.length > 0 && !selectedCountry) {
         setSelectedCountry(countries[0].name);
     }
  }, [countries]);

  useEffect(() => {
     if(selectedCountry && countries?.length > 0) {
         fetchVisaTypes(selectedCountry);
     }
  }, [selectedCountry, countries]);

  return (
    <div>
      <div className="flex flex-row md:items-center justify-between gap-y-5 md:gap-y-0">
        <h1
          onClick={() => console.log(checklists)}
          className="text-sm font-medium md:text-xl"
        >
          Checklists for documents to be uploaded for applications
        </h1>

        {selectedCategory === null && countries?.length > 0 ? (
          <CountrySelector
            selectedCountry={selectedCountry}
            setSelectedCountry={setSelectedCountry}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            countries={countries}
          />
        ) : null}
      </div>

      {!selectedCategory ? (
        <>
          <VisaCategoryList
            selectedCountry={selectedCountry}
            setSelectedCategory={setSelectedCategory}
            visaCategories={visaCategories}
          />

          {/* Separator */}
          <div className="border-t border-slate-300 my-6"></div>

          <BankDetailsForm selectedCountry={selectedCountry} />
        </>
      ) : (
          <DocumentUploadForm
            selectedCategory={selectedCategory}
            selectedCountry={selectedCountry}
            setSelectedCategory={setSelectedCategory}
            countries={countries}
            visaCategories={visaCategories}
            onVisaTypesUpdate={handleVisaTypeUpdate}
          />
      )}
    </div>
  );
};

export default MainDocuments;